import React, { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import router from './routes/app.js'
import { useTranslation } from 'react-i18next'
import './i18n/index.js'
import 'dayjs/locale/zh-cn'
import './App.css'
import { validLicenseSettings } from '@/utils/api.js'
import { Enums, Categories } from '@/utils/settings.js'
import useToken from '@/utils/useToken.js'
import { getEnums } from '@/api/community.js'
import { getCategories } from '@/api/category.js'
import { store } from '@/store'
import { setUserInfo } from '@/store/reducers/userReducer'

window._AMapSecurityConfig = {
  serviceHost: '//api.betasys.cn/_AMapService'
}

validLicenseSettings()

const App = () => {
  const { getToken } = useToken()
  const { i18n } = useTranslation()

  useEffect(() => {
    validLicenseSettings()

    getEnums().then((res) => {
      for (let [key, value] of Object.entries(res)) {
        Enums[key] = value
      }
    })

    getCategories({ filter: { type: 'events' }}).then(res => {
      Categories.entry = res.list
    })

    document.title = i18n.t('title')
  }, [i18n])

  useEffect(() => {
    if (getToken()) {
      store.dispatch(setUserInfo())
    }
  }, [])

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <RouterProvider router={router} />
    </React.Suspense>
  )
}

export default App